export default {"src":"/_next/static/media/modern-room-names-en.45018bb1.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};